export default __webpack_public_path__ + "static/media/new_lg.6c782848.PNG";